export default "__VITE_ASSET__c716cf12__"